var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-widget',_vm._g(_vm._b({attrs:{"multiple":_vm.multiple}},'select-widget',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }